/**
 * @module ArticleMiniCard
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Превью статьи
 */
export default class ArticleMiniCard extends Component {
    static className = 'article-mini-card';
}
